import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '../styles';
import { visionBoardService } from '../services/visionBoard.service';
import { Link } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';
import LoadingSpinner from './LoadingSpinner';

const ExploreBoards = () => {
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const loadBoards = async () => {
      try {
        const data = await visionBoardService.getPublicBoards();
        setBoards(data);
      } catch (error) {
        toast.showToast('Error al cargar los boards', 'error');
      } finally {
        setLoading(false);
      }
    };

    loadBoards();
  }, [toast]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Container>
      <Title>Explora Vision Boards</Title>
      <Description>Descubre la inspiración de otros usuarios</Description>
      <BoardsGrid>
        {boards.map((board) => (
          <StyledLink to={`/${board.username}/board`} key={board.userId}>
            <BoardCard>
              <Avatar 
                src={board.photoURL} 
                alt={board.displayName}
                onError={(e) => {
                  e.target.src = 'https://api.dicebear.com/7.x/avataaars/svg?seed=default';
                }}
              />
              <UserInfo>
                <UserName>{board.displayName || 'Usuario'}</UserName>
                <Username>@{board.username}</Username>
              </UserInfo>
              <CardCount>{board.cardCount} tarjetas</CardCount>
            </BoardCard>
          </StyledLink>
        ))}
      </BoardsGrid>
    </Container>
  );
};

const Container = styled.div`
  padding: 2rem;
  background-color: ${colors.primary};
  min-height: 100vh;
`;

const Title = styled.h1`
  font-family: 'Caveat', cursive;
  font-size: 3rem;
  color: ${colors.text};
  text-align: center;
  margin-bottom: 1rem;
`;

const Description = styled.p`
  font-family: 'Indie Flower', cursive;
  font-size: 1.2rem;
  color: ${colors.text};
  text-align: center;
  margin-bottom: 3rem;
`;

const BoardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const BoardCard = styled.div`
  background-color: ${colors.white};
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px ${colors.shadow};
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px ${colors.shadow};
  }
`;

const Avatar = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid ${colors.secondary};
`;

const UserInfo = styled.div`
  text-align: center;
`;

const UserName = styled.h3`
  font-family: 'Caveat', cursive;
  font-size: 1.8rem;
  color: ${colors.text};
  margin: 0;
`;

const Username = styled.p`
  font-family: 'Indie Flower', cursive;
  font-size: 1.1rem;
  color: ${colors.accent};
  margin: 0;
`;

const CardCount = styled.span`
  font-family: 'Indie Flower', cursive;
  font-size: 1rem;
  color: ${colors.text};
  background-color: ${colors.secondary}20;
  padding: 0.5rem 1rem;
  border-radius: 20px;
`;


const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
`;

export default ExploreBoards; 